import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { type_modal } from 'src/app/helpers/msg-modal.helper';
import { FormMultipleProductsModel } from 'src/app/models/form-multiple-productucs.model';
import { DialogModalComponent } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import Swal from 'sweetalert2';
import { SalesOportunityRequestMap } from '../mappers/sales-opportunity-request.map';
import { SalesOportunitiesRequest } from '../services/sales-oportunities-request.service';
import { RoutesEnum } from 'src/app/shared/enums/routes.enum';
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss', '../../pre-approved-products/common.components.scss']
})
export class FormComponent implements OnInit {
  formDataModel = new FormMultipleProductsModel();
  optProduct = [
    { name: 'Tarjeta de Crédito', image: 'assets/img/img-multi-products/icons/tarjeta_credito.svg', selected: false, id: 'TC' },
    { name: 'Préstamo', image: 'assets/img/img-multi-products/icons/prestamo.svg', selected: false, id: 'LOAN' },
    { name: 'Certificado Financiero', image: 'assets/img/img-multi-products/icons/certificado_financiero.svg', selected: false, id: 'C' },
    { name: 'Cuenta de Ahorro', image: 'assets/img/img-multi-products/icons/cuenta_ahorro.svg', selected: false, id: 'A' },
    { name: 'Seguros', image: 'assets/img/img-multi-products/icons/seguro.svg', selected: false, id: 'S' }
  ];
  
  formSubmitted = false;
  isLoading = false;
  data: any;
    
    constructor(
      private readonly dialog: MatDialog,
      private readonly router: Router,
      private readonly loaction: Location,
    public readonly service: SalesOportunitiesRequest,

    ) {
      if(!!this.router.getCurrentNavigation()?.extras?.state){
      this.data = this.router.getCurrentNavigation()?.extras?.state?.data;
      this.formDataModel.documentId = this.router.getCurrentNavigation()?.extras?.state?.documentId;
      this.formDataModel.fullName = this.router.getCurrentNavigation()?.extras?.state?.fullName;
      this.formDataModel.phone = this.router.getCurrentNavigation()?.extras?.state?.phone;
        
      }
      if(!this.formDataModel.documentId){
        this.loaction.back()
      }
     }

  ngOnInit(): void { }

  selectOptProduct(product) {
    const index = this.formDataModel.selectionOpt.indexOf(product.name);
    if (index > -1) {
      this.formDataModel.selectionOpt.splice(index, 1);
    } else {
      this.formDataModel.selectionOpt.push(product.name);
    }
  }
  public openDialogRechazo(): void {
		this.dialog.open(DialogModalComponent, {
			data: type_modal.msgRechazarOferta,
		});
	}
  async onSubmit(form: any) {
    this.isLoading = true;
    this.formSubmitted = true;
    if (form.valid && this.formDataModel.selectionOpt.length > 0) {
      // Procesar el formulario
      try {
        const requestData = SalesOportunityRequestMap.mapToSalesOpportunityRequest(this.formDataModel, this.data);
       const resp = await this.service.salesOportuniesCreate(requestData);
       this.isLoading = false;   
       
       if(resp?.isSucceded) {
          await Swal.fire({
            icon: 'success',
            title: 'Solicitud registrada correctamente',
            confirmButtonColor: '#FFA400',
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          });
          this.formSubmitted = false;
         return await this.router.navigate([RoutesEnum.ClientConsulMultiProducts], {replaceUrl: true})
        }
        await this.errorModal();
      } catch (error) {
       this.isLoading = false;   
       await this.errorModal();
      }
      
    } 
    this.isLoading = false;
  }
  private async errorModal(){
    await Swal.fire({
      icon: 'error',
      allowOutsideClick: false,
      confirmButtonColor: '#FFA400',
      title: "Aviso",
      text: 'No es posible continuar con el proceso, inténtalo nuevamente en otro momento.'
    });
  }
}

